export default __webpack_public_path__ + "static/menu_bg-fc46d815f0132f2444a4c615a5498675.jpeg";